import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Profile from "./Profile";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import { toast } from "react-toastify";
import uuid from "uuid";
import CloseIcon from "@mui/icons-material/Close";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles, withTheme } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory, useNavigate, useParams } from "react-router-dom";
// import "./Test.css";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px"
    },
    "& .MuiFormLabel-root": {
      color: "#DAD7E9", // or black
      outline: "red",
      fontSize: "13px",
      input: {
        color: "white"
      }
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2)
    },
    "& .MuiInputBase-root": {
      color: "#C0CCD5",
      fontSize: "14px"
    },
    input: {
      backgroundColor: "white",
      color: "white"
    },
    TextField: {
      color: "white"
    }
  }
}));

const Form = ({ handleClose, emails, clicked }) => {
  const { emailForEdit } = useParams();
  const history = useNavigate();
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [flag, setFlag] = useState(false);
  // create state variables for each input
  const [testdata, setTestdata] = useState({});
  const [clicks, setClickeds] = useState(false);
  const [clicking, setClicking] = useState(clicked);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [showSuccess, setShowSuccess] = useState("");
  const [testable, setTestable] = useState();
  const [editData, setEditData] = useState([]);
  let [editId, setEditId] = useState("");
  const [data, setData] = useState({
    __id: "",
    name: "",
    email: "",
    instagram: "",
    telegramUsername: "",
    phoneNumber: "",
    birthday: "",
    joined: "",
    expectedGraduationDate: "",
    shortBio: "",
    university: "",
    department: "",
    leetcode: "",
    codeforces: "",
    favoriteLanguage: "",
    tshirtSize: "",
    tshirtColor: "",
    github: "",
    hackerrank: ""
  });

  useEffect(() => {
    fetch(`https://app.sheetlabs.com/KINF/a2svinfo?__id=${emailForEdit}`)
      .then((response) => response.json())

      .then((data) => setTestdata(data[0]));
    testdata ? setFlag(true) : setFlag(false);
    window.scrollTo(0, 0);
  }, []);

  // useEffect((info) => {
  //   editData.map((info) => {
  //     if (info.Email === emailForEdit) {
  //       setTestable(info)
  //       data.__id = info.__id
  //       data.name = info.Name;
  //       data.email = info.Email;
  //       data.telegramUsername = info.TelegramUsername;
  //       data.phoneNumber = info.PhoneNumber;
  //       data.instagram = info.Instagram;
  //       data.birthday = info.Birthday;

  //       data.joined = info.Joined;

  //       data.shortBio = info.ShortBio;
  //       data.expectedGraduationDate = info.ExpectedGraduationDate;
  //       data.university = info.University;
  //       data.department = info.Department;
  //       data.leetcode = info.Leetcode;
  //       data.hackerrank = info.Hackerrank;
  //       data.codeforces = info.Codeforces;
  //       data.github = info.Github;
  //       data.favoriteLanguage = info.FavoriteLanguage;
  //       data.tshirtColor = info.TshirtColor;
  //       data.tshirtSize = info.TshirtSize;
  //       // console.log(info.Leetcode.split('\n', 1)[0])
  //     }

  //     // console.log(editData)
  //     // console.log(data.)
  //   });
  // });

  // console.log(testdata);
  // console.log(emailForEdit);
  const notify = () =>
    toast.success("Edited account successfully.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 3000
    });

  const URL = "https://app.sheetlabs.com/KINF/a2svinfo";
  // THIS IS a base url for implementing the any kind of request

  // start here
  // useEffect(() => {
  //   axios.get(URL).then((response) => {
  //     setEditData(response.data);
  //     editData ? setFlag(true) : setFlag(false);
  //   });
  // }, [clicked]);

  //Up to this

  // if(clicking){
  //   editData.map((info)=>{
  //     // console.log(info)
  //     if (info.Email === emails){
  //       data.name = info.Name
  //       data.email = info.Email

  //     }
  //   })

  // }
  // console.log(testdata);
  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      // let data = [ {
      //   "__id" : 1,
      //   "Name" : "string",
      //   "Email" : "string",
      //   "TelegramUsername" : "string",
      //   "PhoneNumber" : "string",
      //   "Instagram" : "string",
      //   "Birthday" : "string",
      //   "CV" : "string",
      //   "Joined" : "string",
      //   "Photo" : "string",
      //   "ShortBio" : "string",
      //   "ExpectedGraduationDate" : "string",
      //   "University" : "string",
      //   "Department" : "string",
      //   "Leetcode" : "string",
      //   "Hackerrank" : "string",
      //   "Codeforces" : "string",
      //   "Github" : "string",
      //   "FavoriteLanguage" : "string",
      //   "TshirtColor" : "string",
      //   "TshirtSize" : "string"
      // } ]
      //tje time stamp will goes here
      const dataFor = [
        {
          __id: testdata.__id,
          Name: String(testdata.Name),
          Email: testdata.Email || "",
          TelegramUsername: testdata.TelegramUsername || "",
          PhoneNumber: testdata.PhoneNumber || "",
          Instagram: testdata.Instagram || "",
          Birthday: testdata.Birthday || "",

          Joined: testdata.Joined || "",

          ShortBio: testdata.ShortBio,
          ExpectedGraduationDate: testdata.ExpectedGraduationDate || "",
          University: testdata.University || "",
          Department: testdata.Department || "",
          Leetcode: testdata.Leetcode || "",
          Hackerrank: testdata.Hackerrank || "",
          Codeforces: testdata.Codeforces || "",
          Github: testdata.Github || "",
          FavoriteLanguage: testdata.FavoriteLanguage || "",
          TshirtColor: testdata.TshirtColor || "",
          TshirtSize: testdata.TshirtSize || ""
        }
      ];
      // console.log(testable)
      // fetch("https://app.sheetlabs.com/KINF/a2svinfo" , {
      //   method: 'PATCH',
      //   headers: {
      //     'Content-Type': 'application/json',

      // },
      //   body: JSON.stringify(testable),
      // })
      // .then(response => {
      //   if (response.status === 204) {
      //     console.log('Success!');
      //   } else {

      //     throw new Error('Something went wrong on api server!');

      //   }
      // })
      // .catch((error) => {
      //   console.error('Error:', error);
      // });
      console.log(dataFor);
      setClickeds(true);
      const res = fetch(
        `https://app.sheetlabs.com/KINF/a2svinfo?__id=${emailForEdit}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(dataFor)
        }
      ).then((response) => {
        if (response.ok) {
          setTimeout(() => {
            setShowSuccess(true);
          }, 2000);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const styling = {
    floatingLabelFocusStyle: {
      textField: {
        color: "white"
      }
    }
  };
  const handleChange = (e) => {
    setTestdata({ ...testdata, [e.target.name]: e.target.value });
    // setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ color: "white" }}>
      {!flag ? (
        <div>
          <Backdrop className={classes.backdrop} open>
            {" "}
            <CircularProgress color="inherit" />{" "}
          </Backdrop>
        </div>
      ) : (
        ""
      )}
      <h3 style={{ marginTop: 50 }}>✍🏽 Here you can edit your profile</h3>
      <div className="underline"></div>
      <h4 style={{ marginTop: 20 }}>👉🏽 Edit the following fields❗️</h4>
      <form className={classes.root} onSubmit={handleSubmit}>
        <TextField
          sx={{ input: { color: "green" } }}
          floatingLabelFocusStyle={styling.floatingLabelFocusStyle}
          label="Full Name"
          variant="outlined"
          required
          className={classes.textField}
          value={testdata.Name}
          name="Name"
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          active
          autoFocus={true}
        />
        {/* <TextField
        label="Last Name"
        variant="filled"
        required
        name="instagram"
        value={data.instagram}
        onChange={handleChange}
      /> */}

        <TextField
          label="Email"
          variant="outlined"
          type="email"
          name="Email"
          required
          value={testdata.Email}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          autoFocus={true}
        />
        <TextField
          label="Instagram"
          variant="outlined"
          name="Instagram"
          value={testdata.Instagram}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          autoFocus={true}
        />
        <TextField
          label="Leetcode"
          variant="outlined"
          name="Leetcode"
          required
          value={testdata.Leetcode}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          autoFocus={true}
        />
        <TextField
          label="CodeForce"
          variant="outlined"
          name="Codeforces"
          value={testdata.Codeforces}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          autoFocus={true}
        />
        <TextField
          label="Hackerrank"
          variant="outlined"
          name="Hackerrank"
          autoFocus={true}
          value={testdata.Hackerrank}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="GitHub"
          variant="outlined"
          name="Github"
          value={testdata.Github}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="Telegram account"
          variant="outlined"
          name="TelegramUsername"
          value={testdata.TelegramUsername}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />

        <TextField
          label="Phone"
          variant="outlined"
          name="PhoneNumber"
          value={testdata.PhoneNumber}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="Birthday"
          variant="outlined"
          name="Birthday"
          value={testdata.Birthday}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="University"
          variant="outlined"
          name="University"
          required
          value={testdata.University}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        {/* <TextField
          label="short bio"
          variant="outlined"
          name="ShortBio"
          value={testdata.ShortBio}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        /> */}
        <TextareaAutosize
          aria-label="minimum height"
          minRows={6}
          placeholder="Edit bio"
          name="ShortBio"
          variant="outlined"
          className="textareaforbio"
          value={testdata.ShortBio}
          onChange={handleChange}
          style={{ width: 297, background: "transparent", color: "white" }}
        />
        <TextField
          label="department"
          variant="outlined"
          name="Department"
          required
          value={testdata.Department}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="Joined at"
          variant="outlined"
          name="Joined"
          required
          value={testdata.Joined}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="Expected Gratuation Year"
          variant="outlined"
          name="ExpectedGraduationDate"
          value={testdata.ExpectedGraduationDate}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="Favorite Language"
          variant="outlined"
          name="FavoriteLanguage"
          value={testdata.FavoriteLanguage}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="T-Shirt Size"
          variant="outlined"
          name="TshirtSize"
          value={testdata.TshirtSize}
          autoFocus={true}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
        <TextField
          label="Tshirt Color"
          variant="outlined"
          name="TshirtColor"
          value={testdata.TshirtColor}
          autoFocus={false}
          // ... rest
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />

        <div>
          <Link to="/profile">
            <Button variant="contained" onClick={handleClose}>
              Profile
            </Button>
          </Link>
          <Button
            type="submit"
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            SAVE
          </Button>
        </div>
      </form>

      {!showSuccess && clicks ? (
        <div>
          <Backdrop className={classes.backdrop} open>
            {" "}
            <CircularProgress color="inherit" />{" "}
          </Backdrop>
        </div>
      ) : (
        ""
      )}

      {/* {!showSuccess && (<div>
          <Backdrop className={classes.backdrop} open>
            {" "}
            <CircularProgress color="inherit" />{" "}
          </Backdrop>
        </div>) } */}
      {showSuccess && (
        <Box sx={{ width: "100%" }}>
          <Collapse in={open}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              ✅ You have successfully edited your profile
            </Alert>
          </Collapse>
        </Box>
      )}
    </div>
  );
};

export default Form;

// import {useState , useEffect} from "react"
// import {Input , Button} from "@material-ui/core"
// const Register = ( ) => {
//   const [input , setInput] = useState()
//   function handler(){

//   }
//   return (
//     <div>
//       <h3 style={{margin:10 , color:"white"}}>Welcome to A2SV register</h3>
//       <p style={{marginTop:30}}>Name</p>
//       <Input
//           type="email"
//           value={input}
//           onChange={handler}
//           placeholder="johndeo@gmail.com"
//           style={{

//             marginBottom:28,
//             marginTop:-34,
//             marginRight: 15,
//             paddingTop: 27,
//             paddingRight: 40,
//             color: "white",
//             textAlign:"center",
//             fontFamily: "monospace"
//           }}
//         />

//       <p style={{marginTop:30}}>Name</p>
//       <Input
//           type="email"
//           value={input}
//           onChange={handler}
//           placeholder="johndeo@gmail.com"
//           style={{

//             marginBottom:28,
//             marginTop:-34,
//             marginRight: 15,
//             paddingTop: 27,
//             paddingRight: 40,
//             color: "white",
//             textAlign:"center",
//             fontFamily: "monospace"
//           }}
//         />

//     </div>
//   )
// }
// export default Register
